import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";

const ModuleSetting = Loadable(
  lazy(() => import("./ModuleSetting"))
);

export const moduleSettingRoutes = [
  {
    path: REACT_APP_NAV_ROUTES.moduleSettings,
    element: <ModuleSetting />,
  },
];
